const locale = {
  ACCOUNT_MENU_BUTTON_ARIA_LABEL: 'Menú de cuenta, {{name}}',
  GUEST_NAME: 'Invitado',
  CHANGE_PASSWORD: 'Cambiar Contraseña',
  LOGOUT: 'Salir',
  INSIGHT_PAGE_TITLE: 'Análisis de Brechas',
  STUDENT_OVERVIEW_PAGE_TITLE: 'Resumen de Estudiantes',
  STUDENT_ADVISING_PAGE_TITLE: 'Mentoría Profesional',
  CAREER_TRENDS_PAGE_TITLE: 'Tendencias Profesionales',
  CONTACT_US_PAGE_TITLE: 'Contáctanos',
  FAQ_PAGE_TITLE: 'Preguntas Frecuentes',
  ASIDE_ARIA_LABEL: 'Barra lateral de navegación',
  SKIP_TO_MAIN_CONTENT: 'Saltar al contenido principal',
};

export default locale;
